import CtaSimple from './CtaSimple'
export default CtaSimple
